/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import React from 'react'
import PropTypes from 'prop-types'
import { DateRangePicker } from 'rsuite'
import 'rsuite/dist/styles/rsuite-default.css'
import Helmet from 'react-helmet'
import moment from 'moment'
import './AnalyticsRangePicker.css'

const getDateStringOfDaysAgo = () => moment().subtract(6, 'day')

const AnalyticsRangePicker = ({ setRanges: { setStartDate, setEndDate } }) => {
  const handleChange = value => {
    setStartDate(moment(value[0]).format('YYYY-MM-DD'))
    setEndDate(moment(value[1]).format('YYYY-MM-DD'))
  }

  return (
    <>
      {/* Helmet changes the calendar styles */}
      <Helmet
        style={[
          {
            cssText: `
          .rs-picker-menu {
            z-index: 2147483002 !important;
            left: unset !important;
            right: 30px !important;
          }
        `,
          },
        ]}
      />

      <DateRangePicker
        defaultValue={[getDateStringOfDaysAgo().toDate(), new Date()]}
        format="DD-MM-YYYY"
        ranges={[
          {
            label: 'Last 2 weeks',
            value: [
              moment()
                .subtract(13, 'day')
                .toDate(),
              new Date(),
            ],
          },
          {
            label: 'Last month',
            value: [
              moment()
                .subtract(1, 'month')
                .add(1, 'days')
                .toDate(),
              new Date(),
            ],
          },
        ]}
        showOneCalendar
        size="md"
        onChange={handleChange}
      />
    </>
  )
}

AnalyticsRangePicker.propTypes = {
  setRanges: PropTypes.shape({}).isRequired,
}

export default AnalyticsRangePicker
